import NewTemplateModal from './NewTemplateModal';

import '../../../../SignalViewerContainer/components/NewTemplateModal/NewTemplateModal.scss';

export default NewTemplateModal;
